import axios from 'axios'
import { useAlertsStore } from "../stores/alerts.js";


const apiClient = axios.create({
    baseURL: `/api/api`,
    timeout: 5000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})
apiClient.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    if (error.code === 'ERR_NETWORK') {
        useAlertsStore().add('danger', 'Ein unerwarteter Fehler ist passiert, bist du mit dem Internet verbunden?');
        window.scrollTo(0, 0);
        return Promise.reject();
    }
    if (error.response && error.response.status === 500) {
        useAlertsStore().add('danger', 'Ein interner Serverfehler ist passiert.');
        window.scrollTo(0, 0);
        return Promise.reject();
    }
    if (error.response && error.response.data && Object.hasOwn(error.response.data, 'success') && error.response.data.success === false) {
        useAlertsStore().add('danger', error.response.data.message);
        window.scrollTo(0, 0);
        return Promise.reject();
    }

    console.log("error passiert: ", error);
    return Promise.reject(error);
});

export default {
    async shifts(token, event_id) {
        let config = {
            headers: {
                Authorization: token,
            }
        }
        return await apiClient.get(`/event/${event_id}/shift`, config);
    },
    async events(token) {
        let config = {
            headers: {
                Authorization: token,
            }
        }
        return await apiClient.get(`/event`, config);
    },
}